module.exports = __webpack_public_path__ + "static/img/qrcode.bf7cf51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/float/qrcode.png
// module id = W+3A
// module chunks = 37